import React from "react";
import DashboardMenu from "../Dashboard/DashboardMenu";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerProfileById } from "../../store/Slice/customerProfileSlice";
import { getContractorProfileById } from "../../store/Slice/contractorProfileSlice";

const AfterLoginHeader = () => {
  const dispatch = useDispatch();

  const customerUniqueCode = sessionStorage.getItem("Customer-vUniqueCode");
  const contractorUniqueCode = sessionStorage.getItem("Contractor-vUniqueCode");

  const isCustomerLoggedIn =
    customerUniqueCode && customerUniqueCode !== "undefined";

  const isContractorLoggedIn =
    !isCustomerLoggedIn &&
    contractorUniqueCode &&
    contractorUniqueCode !== "undefined";

  const noImage = "/assets/images/no-image.png";
  const { customerProfileDetailData } = useSelector(
    (state) => state.customerProfileDetail
  );
  const { contractorProfileDetailData } = useSelector(
    (state) => state.contractorProfileDetail
  );
  React.useEffect(() => {
    if (isCustomerLoggedIn) {
      dispatch(
        getCustomerProfileById({
          vUniqueCode: customerUniqueCode,
        })
      );
    } else if (isContractorLoggedIn) {
      dispatch(
        getContractorProfileById({
          vUniqueCode: contractorUniqueCode,
        })
      );
    }
  }, [
    dispatch,
    customerUniqueCode,
    contractorUniqueCode,
    isCustomerLoggedIn,
    isContractorLoggedIn,
  ]);

  const customerProfileData =
    isCustomerLoggedIn &&
    customerUniqueCode !== "undefined" &&
    customerProfileDetailData?.code === 200 &&
    customerProfileDetailData?.data;

  const contractorProfileData =
    isContractorLoggedIn &&
    contractorUniqueCode !== "undefined" &&
    contractorProfileDetailData?.code === 200 &&
    contractorProfileDetailData?.data;

  return (
    <>
      {/* <div className="dashboard"> */}
      <div className="dashboard-nav">
        <DashboardMenu />
      </div>
      <div
        className="offcanvas offcanvas-start dashboard-offcanvas"
        tabIndex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="responsive-close-btn"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="fa fa-close"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          <DashboardMenu />
        </div>
      </div>
      {/* <div className="dashboard-app"> */}
      {customerProfileData ? (
        <header className="dashboard-toolbar">
          <div className="dash-header-titleDiv">
            <a
              className="menu-toggle"
              data-bs-toggle="offcanvas"
              href="#offcanvasExample"
              role="button"
              aria-controls="offcanvasExample"
            >
              <i className="fa fa-bars"></i>
            </a>
            <h3 className="dashboard-headertitle">
              Hello {customerProfileData?.vFirstName}{" "}
              {customerProfileData?.vLastName}
            </h3>
          </div>

          <div className="dropdown login-userdropdown">
            <button className="btn btn-secondary dropdown-toggle" type="button">
              <img
                className="login-usering"
                // src="assets/images/dashboard/user-login.png"
                src={
                  customerProfileData?.vImage &&
                  !customerProfileData?.vImage.endsWith(null)
                    ? customerProfileData?.vImage
                    : noImage
                }
                alt={customerProfileData?.vImageAlt}
              />
              {customerProfileData?.vFirstName} {customerProfileData?.vLastName}
            </button>
          </div>
        </header>
      ) : (
        contractorProfileData && (
          <header className="dashboard-toolbar">
            <div className="dash-header-titleDiv">
              <a
                className="menu-toggle"
                data-bs-toggle="offcanvas"
                href="#offcanvasExample"
                role="button"
                aria-controls="offcanvasExample"
              >
                <i className="fa fa-bars"></i>
              </a>
              <h3 className="dashboard-headertitle">
                Hello {contractorProfileData?.vFullName}
              </h3>
            </div>

            <div className="dropdown login-userdropdown">
              <button
                className="btn btn-secondary dropdown-toggle"
                type="button"
              >
                <img
                  className="login-usering"
                  // src="assets/images/dashboard/user-login.png"
                  src={
                    contractorProfileData?.vImage &&
                    !contractorProfileData?.vImage.endsWith(null)
                      ? contractorProfileData?.vImage
                      : noImage
                  }
                  alt={contractorProfileData?.vImageAlt}
                />
                {contractorProfileData?.vFullName}
              </button>
            </div>
          </header>
        )
      )}
      {/* </div> */}
    </>
  );
};

export default AfterLoginHeader;
